<template>
	<v-container fluid>
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		  	<span class="text-subtitle-1">Recomendados</span>
	  		    <v-spacer></v-spacer>

	  		    <v-btn
              color="orange"
              dark
              class="mr-2"
              @click="dialog = true"
              small
              tile
            >
              <v-icon small>mdi-plus</v-icon>
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>

	  		  </v-card-title>

	  		  <v-card-text>
	  		  	<v-row justify="end">
	  		  		<v-col cols="12" md="6">
	  		  			<v-text-field
	  		  			  name="name"
	  		  			  label="Buscar"
	  		  			  id="id"
	  		  			  filled
	  		  			  dense
	  		  			  hide-details
	  		  			  append-icon="mdi-magnify"
	  		  			  v-model="search"
	  		  			></v-text-field>
	  		  		</v-col>
	  		  	</v-row>
	  		    <v-row>
	  		    	<v-col cols="12">
							  <v-data-table
							    :headers="headers"
							    :items="proyectos"
							    class="elevation-0"
							    :search="search"
							    :mobile-breakpoint="100"
			            dense
							  >
  							  <template v-slot:item.actions="{ item }">
							      <v-icon
							        small
							        @click="deleteItem(item)"
							        color="error"
							      >
							        mdi-delete
							      </v-icon>
							    </template>

							    <template v-slot:no-data>
							      <v-btn
							        color="primary"
							        @click="initialize"
							        small
							      >
							        Actualizar
							      </v-btn>
							    </template>
							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		  <v-card-actions>
            <v-spacer></v-spacer>
            <v-pagination
              circle
              v-model="page"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </v-card-actions>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <v-dialog
      v-model="dialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
	        <v-text-field
	          v-model="editedItem.nombre_completo"
	          label="Nombre completo"
	          filled
	          dense
	          autofocus
	        ></v-text-field>

          <v-select
            v-if="getEscuela == 1"
            :items="[{id:1, nom: 'ANAHUAC'},{id:2, nom:'Miguel Aleman'},{id:3,nom:'Pablo Livas'},{id:4,nom:'San Miguel'},{id:5,nom:'Casa blanca'},{id:6,nom:'Fresnos'},{id:17,nom:'INBI ONLINE'},{id:21,nom:'APODACA CENTRO'},{id:22,nom:'LINCOLN'},{id:23,nom:'ESCOBEDO'},{id:24,nom:'SANTA CATARINA'},{id:25,nom:'MONTEVIDEO'},{id:27,nom:'ARAGON'},{id:28,nom:'MISTERIOS'},{id:29,nom:'TRANSITO'},{id:31,nom:'CUITLAHUAC'}]"
            v-model="editedItem.id_sucursal_interes"
            item-text="nom"
            item-value="id"
            label="Sucursal de intéres"
            filled
            dense
          ></v-select>

          <v-select
            v-else
            :items="[{id:7, nom: 'FAST_APODACA'},{id:8, nom:'FAST_NORIA'},{id:9,nom:'FAST_RG'},{id:10,nom:'FAST_LV'},{id:11,nom:'FAST_ELOY'},{id:12,nom:'FAST_MTR'},{id:14,nom:'FAST_UNI'},{id:16,nom:'FAST ONLINE'}]"
            v-model="editedItem.id_sucursal_interes"
            item-text="nom"
            item-value="id"
            label="Sucursal de intéres"
            filled
            dense
          ></v-select>

	        <v-subheader class="mb-0 pb-0 mt-1">Información de contacto</v-subheader>
	        <v-text-field
	          v-model="editedItem.telefono"
	          label="Teléfono"
	          filled
	          type="number"
	          dense
	          @keyup.enter="buscarTelefono( editedItem.telefono )"
	        ></v-text-field>

	        <v-row>
	          <v-col cols="6">
	            <label>Horario de interés</label>
	            <v-radio-group v-model="editedItem.horario_interes">
	              <v-radio
	                label="Mañana"
	                value="Mañana"
	              ></v-radio>
	              <v-radio
	                label="Tarde"
	                value="Tarde"
	              ></v-radio>
	              <v-radio
	                label="Noche"
	                value="Noche"
	              ></v-radio>
	              <v-radio
	                label="Fin de semana"
	                value="Fin de semana"
	              ></v-radio>
	            </v-radio-group>
	          </v-col>

	          <v-col cols="6">
	            <label>Curso de interés</label>
	            <v-radio-group v-model="editedItem.curso_interes">
	              <v-radio
	                v-for="(curso, i) in cursos_escuela"
	                :key="i"
	                :label="curso.curso"
	                :value="curso.idcursos_escuela"
	              ></v-radio>
	            </v-radio-group>
	          </v-col>
	        </v-row>
	      </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            small
            @click="close"
          >
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            class=""
            tile
            dark
            small
            @click="save"
          >
            <v-icon small left>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row>
	      		<v-col cols="12">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-h6" style="display: table-cell; vertical-align: middle;">
		      				<strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el contacto?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text large class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C" dark class="elevation-6" large @click="deleteItemConfirm()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>

    <Alerta    v-if="respuestaAlerta" :parametros="parametros"/>
    <Loader    v-if="cargar"          :loader="loader"/>

	</v-container>
</template>
<script>
import axios from 'axios';

	// Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'

	import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  import { mapGetters } from 'vuex'

  export default {

    mixins: [ validarErrores, funcionesExcel ],

    components:{
      Alerta,
      Loader,
    },

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      headers: [
        { text: 'ID'       , align: 'start', value: 'folio' },
        { text: 'Nombre'   , value: 'nombre_completo'   },
        { text: 'Teléfono' , value: 'telefono'          },
        { text: 'Actions'  , value: 'actions', sortable: false },
      ],
      proyectos: [],
      editedIndex: -1,
      editedItem: {
        nombre_completo:'',
      	idleds:'',
      	escuela: 2,
      	iddetalle_fuentes:0,
        idfuentes: 0,
        fuente: '',
        estatus: '',
        foraneo: 0,
        idcursos_escuela: 0,
        telefono:'',
        sucursal:0,
        nota_inicial:'El alumno es un recomendado',
        idmedio_contacto:0,
        idcampanias:0,
        id_sucursal_interes:0,
        curso_interes: 0,
        horario_interes:'',
        respondio: 0,
      },
      defaultItem: {
        nombre_completo:'',
        idfuentes: 0,
        idleds:'',
      	escuela: 2,
      	iddetalle_fuentes:0,
        fuente: 0,
        estatus: '',
        foraneo: 0,
        idcursos_escuela: 0,
        telefono:'',
        sucursal:0,
        nota_inicial:'El alumno es un recomendado',
        idmedio_contacto:0,
        idcampanias:0,
        id_sucursal_interes:0,
        curso_interes: 0,
        horario_interes:'',
        respondio: 0,
      },

      // tabla
			search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,


      cursos_escuela:[],
      vendedoras:[],
      vendedoras_plantel:[],
      vendedora:null
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar interesado' : 'Editar interesado'
      },

      ...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecursosGrupoUsuario', 'getGrupos', 'getEscuela' ]),

    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

      'editedItem.estatus': function(newVal) {
      this.editedItem.estatus = newVal ? 1 : 0;
      }
    },

    created () {
      this.initialize()
      this.getCursosEscuela( )
      this.getVendedoras( )
    },

    methods: {
      initialize () {
        this.proyectos = []
        this.cargar = true
        this.$http.get('consultar.recomendados/' + this.getUsuarioLMS.iderp ).then(response=>{
        	this.proyectos = response.data
            
        	this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getVendedoras() {
	      this.cargar = true
	      this.vendedoras  = []
	      return this.$http.get('vendedoras.list').then((response) => {


	      	// Primero, sacamos si el alumno tiene grupos
	      	let id_plantel = this.getGrupos[ this.getGrupos.length - 1 ].id_plantel

	        // Llenamos la etapa incial
	        this.vendedoras = response.data
	        this.vendedoras_plantel = this.vendedoras.filter(el=> { return el.escuela == this.getEscuela && el.idplantel == id_plantel })

	        this.vendedora = this.vendedoras_plantel.length ? this.vendedoras_plantel[0] : null
	        this.cargar    = false
	      }).catch( error =>{
	        this.validarError( error )
	      }).finally( () => { this.cargar = false })
	    },

      getCursosEscuela() {
	      this.cargar = true
	      this.cursos_escuela  = []
	      return this.$http.get('escuela.cursos.activos').then((response) => {
	        // Llenamos la etapa incial
	        this.cursos_escuela = response.data.filter( el=> { return el.escuela == this.getEscuela })
	        this.cargar      = false
	      }).catch( error =>{
	        this.validarError( error )
	      }).finally( () => { this.cargar = false })
	    },

      editItem (item) {
        this.editedIndex = this.proyectos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.proyectos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        // Lo mandapos por el EP
        this.editedItem.deleted = 1
        this.$http.put('leds.update/' + this.editedItem.idleds, this.editedItem).then(response=>{
        	this.validarSuccess('Datos eliminados correctamente')
        	this.cargar        = false
        	this.closeDelete()
        	this.initialize()
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save ( item ) {

	      // Ponerle pendiente a su nombre completo
	      if(this.editedItem.nombre_completo == ''){ this.editedItem.nombre_completo = 'Pendiente' }

	    	// Activamos el loader
	      this.cargar = true

	    	this.editedItem['id_alumno'] = this.getUsuarioLMS.iderp

	      // Lo mandapos por el EP
	      this.$http.post('leds.add', this.editedItem).then(response=>{
	        if( this.editedItem.telefono ){
	          this.addContacto( this.editedItem , response.data.id )
	        }else{
	        	this.validarSuccess( 'Lead agregado correctamente ')
	          this.close()
	        	this.initialize()
	        }
	      	this.cargar      = false
	      }).catch( error =>{
	        this.validarError( error )
	      }).finally( () => { this.cargar = false })
	    },


      addContacto ( lead , idleds ) {

	      //recibe los campos del form
	      //guardo en una variable los datos a guardar id = this.editedItem.idcurso;
	      var payload = {
	        nombre_completo   : lead.nombre_completo,
	        telefono          : lead.telefono,
	        correo            : lead.email,
	        sucursal_interes  : this.vendedora ? this.vendedora.idplantel : 0,
	        sucursal_interes_2: this.editedItem.id_sucursal_interes,
	        curso_interes     : this.editedItem.curso_interes,
	        horario_interes   : this.editedItem.horario_interes,
	        usuario_creo      : this.getUsuarioLMS.iderp,
	        usuario_asignado  : this.vendedora ? this.vendedora.idusuario : 0,
	        nota_inicial      : lead.nota_inicial,
	        folio             : '',
	        acronimo          : this.vendedora ? this.vendedora.acronimo : 0,
	        escuela           : this.getEscuela,
	        idpuesto          : 0,
	        como_llego        : 0,
	        idleds            : idleds
	      }

	      this.cargar = true

	      this.$http.post('prospectos.add', payload).then(response  => {
	        this.cargar = false
	        this.editedItem           = Object.assign({}, this.defaultItem)
	        this.editedItem.sucursal  = null
	        this.anuncio              = null
	        this.vendedora            = null
	        this.validarSuccess( 'Contacto generado correctamente' )
	        this.close()
	        this.initialize();
	        this.cargar      = false
	      }).catch( error =>{
	        // Hay que eliminar el lead
	        this.validarError( error )
	      }).finally( () => { this.cargar = false })
	    },
    },
  }
</script>
